import {
    GET_FEE_MARKUP_LIST_SUCCESS,
    GET_FEE_MARKUP_LIST_FAILED,
    RESET_GET_FEE_MARKUP_LIST,
    LOADING_GET_FEE_MARKUP_LIST,
    NETWORK_ERROR_GET_FEE_MARKUP_LIST,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GET_FEE_MARKUP_LIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };

        case GET_FEE_MARKUP_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };

        case GET_FEE_MARKUP_LIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };

        case NETWORK_ERROR_GET_FEE_MARKUP_LIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };

        case RESET_GET_FEE_MARKUP_LIST:
            return (state = initialState);

        default:
            return state;
    }
};